/* eslint-disable react/jsx-wrap-multilines */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import AdjustmentFactorContent from './AdjustmentFactorContent';
import AdjustmentFactorModal from '../modal/AdjustmentFactorModal';
import * as actions from '../action';
import * as c from '../constant';

const form = {
  keyword: '',
};
function AdjustmentFactorContainer({
  match,
  history,
  getAdjustmentFactorList,
  adjustmentFactorList,
  isLoading,
  adjustmentFactorListPager,
  getSingleAdjustmentFactor,
  removeAdjustmentFactor,
  ordinanceRevisionId,
  clearItem,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <AdjustmentFactorModal
          type="NEW"
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Add Adjustment Factor',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <AdjustmentFactorModal
          adjustmentFactorInfo={data.attributes}
          id={data.id}
          type="EDIT"
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Update Adjustment Factor',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this Adjustment Factor?',
      () => {
        removeAdjustmentFactor(data.id, () => {
          getAdjustmentFactorList({
            ordinance_revision_id: ordinanceRevisionId,
          });
          const id = _.get(adjustmentFactorList, '0.id');
          history.push(`/rpt/land/land-settings/adjustment-factor/${id}`);
          getSingleAdjustmentFactor(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getAdjustmentFactorList(
      {
        isPaginate: 1,
        ordinance_revision_id: ordinanceRevisionId,
      },
      (res) => {
        const id = _.get(res, 'data.0.id');
        if (id) {
          history.push(`/rpt/land/land-settings/adjustment-factor/${id}`);
          getSingleAdjustmentFactor(id);
        } else clearItem(c.GET_SINGLE_ADJUSTMENT_FACTOR, {});
      }
    );
    return () => {
      setModal({ isOpen: false });
    };
  }, [ordinanceRevisionId]);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getAdjustmentFactorList({
        q: formData.keyword,
        isPaginate: 1,
        ordinance_revision_id: ordinanceRevisionId,
      });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:adjustmentFactorId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Adjustment Factor"
            getData={getAdjustmentFactorList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:adjustmentFactorId?`}
            listName="adjustmentFactors"
            label="Adjustment Factor"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.name')}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {' '}
                  Adjustment Percentage:{' '}
                  {_.get(item, 'attributes.percentage_adjustment')}{' '}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            selected={params.adjustmentFactorId}
            data={adjustmentFactorList}
            dataPager={adjustmentFactorListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:adjustmentFactorId?`}
                    render={() => (
                      <AdjustmentFactorContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:adjustmentFactorId?`}
                  render={() =>
                    !params.adjustmentFactorId &&
                    adjustmentFactorList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(
                          adjustmentFactorList,
                          '0.id'
                        )}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

AdjustmentFactorContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getAdjustmentFactorList: PropTypes.instanceOf(Function).isRequired,
  adjustmentFactorList: PropTypes.instanceOf(Array).isRequired,
  adjustmentFactorListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  getSingleAdjustmentFactor: PropTypes.instanceOf(Function).isRequired,
  removeAdjustmentFactor: PropTypes.instanceOf(Function).isRequired,
  clearItem: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  adjustmentFactorList:
    _.get(api, `${c.GET_ADJUSTMENT_FACTOR_LIST}.list`) || [],
  adjustmentFactorListPager:
    _.get(api, `${c.GET_ADJUSTMENT_FACTOR_LIST}.pager`) || {},
  isLoading:
    _.get(api, 'loading', []).indexOf(c.GET_ADJUSTMENT_FACTOR_LIST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(AdjustmentFactorContainer);
